var ms = 300; // Fade duration
function hide_all() {
	$("#Nonwoven").hide();
	$("#Woven").hide();
	$("#Geogrid").hide();
	$("#value-text").hide();
	$("#value-range-text").hide();
	$("#submit").parent().hide();
}
function initProductFinder() {

	$("#product-finder-form").validate({
		rules:{
			'value':'required'
		},
		messages:{
			'value':''
		},
		submitHandler: function() {
			$.ajax({
				data: $('#product-finder-form').serialize(),
				dataType:'html',
				success:function(data){										
					$("#product-finder-results").html(data).slideDown('medium');
					if($('#product-finder-results #product-finder-results-wrapper').length>0){
						var myElement = document.getElementById('product-finder-results-wrapper');
						var el = new SimpleBar(myElement, { autoHide: true });
					}
					
				} 
			});
		}		
	});
	
	// On type selection
	$('.dropdown-type-item').click(function() {
		hide_all();
		var type_id = $(this).data("id");
		$("#" + type_id).fadeIn(ms);	
		var item_text = $(this).text();
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
		$("#product-finder-form #type").val(type_id);
		return false;
	});
	
	// On property selection
	$('.dropdown-property-item').click(function() {
		var property_id = $(this).data("id");
		var item_text = $(this).text();
		$("#value-text").fadeIn(ms);
		$("#value-range-text").fadeIn(ms);
		$("#submit").parent().fadeIn(ms);
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
		$("#product-finder-form #property_id").val(property_id);
		return false;
	});
	
	// On application selection
	$('.dropdown-application-item').click(function() {
		var application_id = $(this).data("id");	
		var item_text = $(this).text();
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
		$("#product-finder-form #application").val(application_id);
		return false;
	});
	$("#submit").click(function() {
		$('#product-finder-form').submit();
		return false;
	});
	

	/* TOUCHSTART EVENT FOR IPHONE */

	// On type selection
	$(document).on('touchstart','.dropdown-type-item', function(e) {
		e.preventDefault();
		hide_all();
		var type_id = $(this).data("id");
		var item_text = $(this).text();
		$("#" + type_id).fadeIn(ms);	
		$("#product-finder-form #type").val(type_id);
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
	});
	
	// On property selection
    $(document).on('touchstart','.dropdown-property-item', function(e) {

		e.preventDefault();
		var property_id = $(this).data("id");
		$("#value-text").fadeIn(ms);
		$("#value-range-text").fadeIn(ms);
		$("#submit").parent().fadeIn(ms);
		var item_text = $(this).text();
		$("#product-finder-form #property_id").val(property_id);
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");

	});
	
	// On application selection
    $(document).on('touchstart','.dropdown-application-item', function(e) {
		e.preventDefault();
		var application_id = $(this).data("id");	
		var item_text = $(this).text();
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
		$("#product-finder-form #application").val(application_id);
	});
	
	
	$("#pack-product-finder-form").validate({
		rules:{
			'volume':'required'
		},
		messages:{
			'volume':''
		},
		submitHandler: function() {
			$.ajax({
				data: $('#pack-product-finder-form').serialize(),
				dataType:'html',
				success:function(data){										
					$("#product-finder-results").html(data).slideDown('medium');
					if($('#product-finder-results #product-finder-results-wrapper').length>0){
						var myElement = document.getElementById('product-finder-results-wrapper');
						var el = new SimpleBar(myElement, { autoHide: true });
					}
				} 
			});
		}		
	});

	$('.dropdown-shape-item').click(function() {
		var shape = $(this).data("id");	
		var item_text = $(this).text();
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
		$("#pack-product-finder-form #shape").val(shape);
		return false;
	});

	$('.dropdown-diameter-item').click(function() {
		var diameter = $(this).data("id");	
		var item_text = $(this).text();
		$("#pack-product-finder-form #diameter").val(diameter);
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
		return false;
	});
	$('.dropdown-volume-item').click(function() {
		var volume_unit = $(this).data("id");
		var item_text = $(this).text();	
		$(this).parent().parent().parent().find('button.dropdown-toggle').html('<span>'+item_text+'</span> <b class="caret"></b>').dropdown("toggle");
		$("#pack-product-finder-form #volume_unit").val(volume_unit);
		return false;
	});
	
	$("#pack-submit").click(function() {
		$('#pack-product-finder-form').submit();
		return false;
	});
	
	/* TOUCHSTART EVENT FOR IPHONE */
	$('.dropdown-shape-item').on('touchstart', function(e) {
		e.preventDefault();
		var shape = $(this).data("id");	
		var item_text = $(this).text();	
		$(this).parent().parent().parent().find('button.dropdown-toggle').html(item_text+' <b class="caret"></b>').dropdown("toggle");
		$("#pack-product-finder-form #shape").val(shape);
	});

	$('.dropdown-diameter-item').on('touchstart', function(e) {
		e.preventDefault();
		var diameter = $(this).data("id");
		var item_text = $(this).text();	
		$(this).parent().parent().parent().find('button.dropdown-toggle').html(item_text+' <b class="caret"></b>').dropdown("toggle");
		$("#pack-product-finder-form #diameter").val(diameter);
	});
	$('.dropdown-volume-item').on('touchstart', function(e) {
		e.preventDefault();
		var volume_unit = $(this).data("id");	
		var item_text = $(this).text();	
		$(this).parent().parent().parent().find('button.dropdown-toggle').html(item_text+' <b class="caret"></b>').dropdown("toggle");
		$("#pack-product-finder-form #volume_unit").val(volume_unit);
	});
	
	$("#pack-submit").on('touchstart', function(e) {
		e.preventDefault();
		$('#pack-product-finder-form').submit();
	});

	$('#product-finder-results .close').on('click',function() {
		$("#product-finder-results").slideUp('medium',function(){
			$(this).empty();	
		});
	});
	
}